module.exports = __webpack_public_path__ + "img/icon.5f898d5e.png";